module.exports = __webpack_public_path__ + "7faac6775a7dcc96653f7ed646f11dba.png";